/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-syntax */

/**
 * Utility to format color scales to be used in theming.
 *
 * Usage:
 *
 * ```jsx
 * import { formatScale } from '@one-thd/sui-atomic-components';
 *
 * const { outputScale1, outputScale2 } = formatScales({ scale1, scale2 })
 * ```
 */
export const formatScales = (scales = {}) => {

  let formattedScales = {};

  const flattenScale = (obj) => {
    for (let key in obj) {
      if (Object.hasOwn(obj[key], 'value')) {
        const scaleString = key.toLowerCase().split('-');
        const scaleName = scaleString[0];
        const scaleWeight = scaleString[1].replace(/^0+/, '');
        const channels = obj[key].value;
        formattedScales[scaleName] = {
          ...formattedScales[scaleName],
          [scaleWeight]: channels
        };
      } else if (typeof obj[key] == 'object') {
        flattenScale(obj[key]);
      }
    }
  };

  flattenScale(scales);
  return formattedScales;
};